import {DashboardMetrics} from "../../../components/dashboard-metrics";
import {TransactionsTable} from "../../../components/transactions";
import {DashboardWrapper} from "../../../layouts/dashboard-wrapper";
import {
  StyledPageHeader,
  StyledPageWrapper,
} from "../../../styles/transactions/transactions";
const TransactionsPage = () => {
  return (
    <DashboardWrapper pageTitle="Transactions">
      <StyledPageHeader>Transactions</StyledPageHeader>
      <StyledPageWrapper>
        <DashboardMetrics />
        <TransactionsTable />
      </StyledPageWrapper>
    </DashboardWrapper>
  );
};

export {TransactionsPage};
